import { useTheme } from '@mui/material';

import { colors } from '@constants/colors';
import { ScreenSizes } from '@interfaces';

export const useStyles = () => {
  const { breakpoints } = useTheme();

  return {
    drawer: {
      '& .MuiDrawer-paper': {
        [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
          top: 76,
          left: '50%',
          right: 'unset',
          transform: 'translateX(-50%) !important',
        },
      },
    },
    root: {
      display: 'flex',
      gap: 3,
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        gap: 2,
        height: '100%',
      },
    },
    container: (isMobile = false) => ({
      width: isMobile ? 518 : 378,
      maxWidth: 'calc(100vw - 32px) !important',
    }),
    column: {
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
    },
    scrollable: {
      maxHeight: 'calc(100vh - 226px)',
      height: 264,

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        height: 'calc(100vh - 168px)',
        maxHeight: 'calc(100dvh - 158px)',
      },
    },
    scrollableContent: {
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        height: '100%',
        maxHeight: '222px',
      },
    },
    divider: {
      backgroundColor: colors.white_20,
    },
  };
};
